import React from 'react'
import PropTypes from 'prop-types'
import st from './FormLabel.module.scss'

const FormLabel = (props) => {
  if (!props.showLabel) return null

  return (
    <div className={props.isRequired ? st.formLabelRequired : st.formLabel}>
      {props.children}
    </div>
  )
}

FormLabel.propTypes = {
  isRequired: PropTypes.bool,
  showLabel: PropTypes.bool,
}

FormLabel.defaultProps = {
  showLabel: true,
}

export default FormLabel
